import axios from 'CanExConfig/axios'

export const getCurrentUser = async () => {
  const response = await axios('/api/current_user', {
    method: 'GET',
  })

  return response.data
}
